<template>
    <div class="tt_work_record" @touchmove.prevent="" v-loading.fullscreen="isLoading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.6)">
        <canvas id="record-canvas" ref="record-canvas" style="position:absolute; top:-99999999px; left:-9999999999px;z-index: 1"></canvas>
        <div class="tt_record_head">
            <div class="tt_record_head_order">{{activeQuestion.order}}</div>
            <span class="tt_record_head_title">{{activeQuestion.typeName}}</span>
        </div>
        <div class="tt_record_container">
            <div id="element-record" ref="element-record" class="element_record" :style="{'overflow-y': elementScrolling ? 'auto' : 'hidden'}">
                <canvas id="drawing-board" ref="drawing-board" class="element_record_board"></canvas>
            </div>
            <div class="video_content" style="display: none;">
                <video controls autoplay playsinline id="preview-video"></video>
            </div>
            <div v-show="drawingTotalPage > 1" class="element_scrolling">
                <img @click="lastElement" class="element_scrolling_top" src="../../assets/image/ttWork/record/scroll-icon.png" :style="{cursor: drawingPage > 1 ? 'pointer' : 'not-allowed'}" alt="上一页">
                <img @click="nextElement" class="element_scrolling_bottom" src="../../assets/image/ttWork/record/scroll-icon.png" :style="{cursor: drawingPage < drawingTotalPage ? 'pointer' : 'not-allowed'}" alt="下一页">
            </div>
            <div class="tt_record_panel">
                <QuestionPanel :question-info="activeQuestion"></QuestionPanel>
            </div>
        </div>
        <div class="tt_record_foot">
            <div class="record_foot_part">
                <button class="record_foot_back" @click="backRoute" :disabled="$route.query.paperId">返回</button>
                <div v-show="!isRecordingStarted && !isPauseRecording" @click="readyStartRecord" class="record_btn">
                    <img class="record_start_img" src="../../assets/image/ttWork/record/record-icon.png" alt="">
                    <div>录制微课</div>
                </div>
                <div v-show="!isRecordingStarted && !isPauseRecording && (activeQuestion.explainUrl || isEncoding)" @click="showVideoPlayer = !isEncoding" class="record_btn">
                    <img class="record_img" src="../../assets/image/ttWork/record/play-icon.png" alt="">
                    <div>{{isEncoding ? '转码中' : '播放'}}</div>
                </div>
                <div v-show="isRecordingStarted || isPauseRecording" @click="cancelRecord" class="record_btn">
                    <img class="record_img" src="../../assets/image/ttWork/record/cancel-icon.png" alt="">
                    <div>取消</div>
                </div>
                <div v-show="isRecordingStarted && !isPauseRecording" @click="pauseRecord" class="record_btn">
                    <img class="record_img" src="../../assets/image/ttWork/record/pause-icon.png" alt="">
                    <div>{{showRecordTime}}</div>
                </div>
                <div v-show="isPauseRecording" @click="resumeRecord" class="record_btn">
                    <img class="record_img" src="../../assets/image/ttWork/record/resume-icon.png" alt="">
                    <div>继续</div>
                </div>
                <div v-show="isRecordingStarted || isPauseRecording" @click="stopRecord" class="record_btn">
                    <img class="record_img" src="../../assets/image/ttWork/record/save-icon.png" alt="">
                    <div>保存</div>
                </div>
            </div>
            <div class="record_foot_part">
                <div @click="drawRevocation" class="draw_btn">
                    <img class="revocation_img" src="../../assets/image/ttWork/record/revocation-icon.png" alt="">
                    <div>撤销</div>
                </div>
                <div @click="drawReset" class="draw_btn">
                    <img class="reset_img" src="../../assets/image/ttWork/record/reset-icon.png" alt="">
                    <div>重置</div>
                </div>
                <div v-show="false" class="draw_btn">
                    <img class="answer_img" src="../../assets/image/ttWork/record/answer-icon.png" alt="">
                    <div>答案</div>
                </div>
                <button class="question_btn" @click="lastQuestion" :disabled="activeQuestion.order === 1">上一题</button>
                <button class="question_btn" @click="nextQuestion" :disabled="activeQuestion.order === questionList.length">下一题</button>
                <el-popover
                        popper-class="work-record-order-dialog"
                        placement="top"
                        width="260"
                        v-model="studentCodeDialog">
                    <div class="order_container">
                        <div class="order_content">
                            <div v-for="item in questionList" :key="item.id" @click="jumpQuestion(item)" class="order_item" :class="{'active': item.id === activeQuestion.id}">{{item.order}}</div>
                        </div>
                    </div>
                    <button slot="reference" class="selectQuestion">选择题号</button>
                </el-popover>
            </div>
        </div>
        <OssUpload ref="ossUpload" @uploadSuccess="uploadSuccess(arguments)">
        </OssUpload>
        <VideoPlayer v-model="showVideoPlayer" :play-url="activeQuestion.explainUrl"></VideoPlayer>
    </div>
</template>

<script>
    import RecordRTC from 'recordrtc';
    import QuestionPanel from './components/QuestionPanel';
    // import html2canvas from 'html2canvas'
    import {fullScreen} from '../../components/mixins/fullScreen'
    export default {
        mixins: [fullScreen],
        components: {
            QuestionPanel,
            OssUpload: () => import('./components/OssUpload'),
            VideoPlayer: () => import('./components/VideoPlayer')
        },
        name: "TongTongWorkRecord",
        data () {
            return {
                isEncoding: false, // 视频转码提示
                isLoading: false, // loading
                elementScrolling: false, // 画板滚动
                // 录制
                recorder: null, // 录制实例
                recorderTime: 0, // 录制时长
                elementRecord: null, // 录制的dom元素
                recordCanvas: null, // 录制的canvas
                recordCanvasContext: null, // 录制的canvas context
                isRecordingStarted: false, // 录制是否开始
                isStoppedRecording: false, // 录制是否停止
                isPauseRecording: false, // 录制是否暂停
                canvasStream: null, // 视频流
                audioStream: null, // 音频流
                // 手写板
                drawingBoard: null, // 手写板的canvas
                drawingBoardContext: null, // 手写板的canvas context
                historyDrawData: [], // 手写板历史数据 10步
                isClear: false, // 手写板是否橡皮擦模式
                drawingColor: 'red', // 手写板 笔的颜色
                drawingWith: 1, // 手写板 笔的粗细
                drawingPage: 1, // 手写板 页数
                drawingTotalPage: 1, // 手写板总页数
                // 试卷题目列表
                questionList: [], // 题目列表
                activeQuestion: {}, // 当前题目信息
                // 题目图片信息
                questionImg: null, // 图片对象
                imgLoad: false, // 图片加载完成
                imgWidth: 0, // 图片宽度
                imgHeight: 0, // 图片高度
                imgDataUrl: null, // 图片base64
                // 题目图片url
                questionUrl: '',
                saveQuestionId: null, //保存完后进入下一题的id
                // 切换学生
                studentCodeDialog: false,
                // 播放音视频
                showVideoPlayer: false,
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('contextHead', false);
            });
        },
        beforeRouteLeave (to, from, next) {
            this.$store.dispatch('contextHead', true);
            this.exitFullscreen();
            next()
        },
        computed: {
            // 录制时间
            showRecordTime () {
                const time = Math.floor(this.recorderTime / 10);
                const min = Math.floor(time / 60);
                const second = time % 60;
                return `${min >= 10 ? min : '0' + min}:${second >= 10 ? second : '0' + second}`
            }
        },
        created () {
            // this.$confirm('是否全屏？', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.launchFullscreen();
            // }).catch(() => {
            // });
            if (this.$route.query.paperId) {
                this.$store.commit('workActivePaper', {
                    id: this.$route.query.paperId
                });
            }
            if (this.$route.query.targetId || this.$route.query.targetId === '') {
                this.$store.commit('workActiveClass', {
                    id: this.$route.query.targetId
                })
            } else if (this.$store.state.work.activeClass.id === '全部') {
                this.$store.commit('workActiveClass', {
                    id: ''
                })
            } else {
                this.$store.commit('workActiveClass', {
                    id: this.$store.state.work.activeClass.id
                })
            }
            if (this.$route.query.questionId) {
                this.$store.commit('workActiveQuestion', {
                    id: this.$route.query.questionId
                });
                this.$router.push({
                    query: {
                    },
                });
            }
            this.getPaperDetail().then((e) => {
                if (e) {
                    if (this.$store.state.work.activeQuestion && this.$store.state.work.activeQuestion.id) {
                        this.setQuestion(this.$store.state.work.activeQuestion.id)
                    } else {
                        this.setQuestion(this.questionList[0].id)
                    }
                }
            });
        },
        mounted () {
            this.initRecord();
        },
        methods: {
            // 获取试卷信息
            getPaperDetail () {
                this.isLoading = true;
                return this.$https.get(`/api/tk/ttwork/home/detail`, {
                    params: {
                        id: this.$store.state.work.activePaper.id,
                        schoolYear: this.$store.state.work.activeSchoolYear.id,
                        target: this.$store.state.work.activeClass.id === '全部' ? '' : this.$store.state.work.activeClass.id
                    }
                }).then((response)=>{
                    if (response.code === 0) {
                        if (response.data.errorReasons && Array.isArray(response.data.errorReasons) && response.data.errorReasons.length) {
                            this.questionList = response.data.errorReasons.map(i => { return i });
                            this.isLoading = false;
                            return true
                        }
                    }
                    this.$notify.error({
                        title: '错误',
                        message: '未获取到试卷题目，请重试！',
                        offset: 50
                    });
                    this.isLoading = false;
                    return false
                },(error) => {
                    this.isLoading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                    return false
                }).catch(errors => {
                    this.isLoading = false;
                    this.$errorLog(errors);
                    return false
                })
            },
            // 获取题目信息
            getQuestionDetail (questionId) {
                this.isLoading = true;
                return this.$https.get('/api/tk/ttwork/question/detail', {
                    params: {
                        id: this.$store.state.work.activePaper.id,
                        questionId: questionId,
                        picParam: `image/resize,p_${50}`,
                        target: (this.$store.state.work.activeClass && this.$store.state.work.activeClass.id) || ''
                    }
                }).then((response)=>{
                    if (response.code === 0) {
                        let info = JSON.parse(JSON.stringify(response.data));
                        this.questionList.every(item => {
                            if (item.id === questionId) {
                                info.order = item.order;
                                info.id = questionId;
                                info.typeName = item.typeName;
                                return false
                            }
                            return true
                        });
                        this.activeQuestion = info;
                        this.$store.commit('workActiveQuestion', {
                            id: this.activeQuestion.id
                        });
                    }
                    this.isLoading = false;
                },(error) => {
                    this.isLoading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                }).catch(errors => {
                    this.isLoading = false;
                    this.$errorLog(errors);
                });
            },
            // 上一题
            lastQuestion () {
                this.changeQuestion(this.questionList[this.activeQuestion.order - 2].id);
            },
            // 下一题
            nextQuestion () {
                this.changeQuestion(this.questionList[this.activeQuestion.order].id);
            },
            // 跳转
            jumpQuestion (question) {
                if (question.id === this.activeQuestion.id) return;
                this.studentCodeDialog = false;
                this.changeQuestion(question.id);
            },
            // 切换题目
            changeQuestion (questionId) {
                // 判断是否正在录制视频
                if (this.isRecordingStarted || this.isPauseRecording) {
                    this.$confirm('正在录制视频，是否保存？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.saveQuestionId = questionId;
                        this.stopRecord();
                    }).catch(() => {
                    });
                } else {
                    this.setQuestion(questionId)
                }
            },
            // 切换初始化题目 画板等信息
            async setQuestion (questionId) {
                await this.getQuestionDetail(questionId);
                if (!this.activeQuestion.url) {
                    this.$notify.error({
                        title: '错误',
                        message: '未获取到题目图片，请检查重试！',
                        offset: 50
                    });
                    return;
                }
                this.questionUrl = this.activeQuestion.url.replace('http://', 'https://');
                // 手写板初始化
                this.initDrawBoard();
            },
            // 初始化录制信息
            initRecord () {
                // 录制初始化
                // this.elementRecord = this.$refs.elementRecord;
                this.elementRecord = document.getElementById('element-record');
                // this.recordCanvas = this.$refs.recordCanvas;
                this.recordCanvas = document.getElementById('record-canvas');
                this.recordCanvasContext = this.recordCanvas.getContext('2d');
                this.recordCanvas.width = this.elementRecord.clientWidth;
                this.recordCanvas.height = this.elementRecord.clientHeight;
                this.isRecordingStarted = false;
                this.isStoppedRecording = false;
                this.isPauseRecording = false;
                this.recorderTime = 0;
                // 初始化截图定时器
                this.recordLoop();
            },
            // 手写板初始化
            initDrawBoard () {
                // this.drawingBoard = this.$refs.drawingBoard;
                this.drawingBoard = document.getElementById('drawing-board');
                this.drawingBoardContext = this.drawingBoard.getContext('2d');
                this.historyDrawData = [];
                const img = new Image();
                let imgCanvas = document.createElement('canvas');
                const imgCanvasCtx = imgCanvas.getContext('2d');
                this.imgLoad = false;
                img.crossOrigin = 'Anonymous';
                img.src = this.questionUrl;
                img.onload = () => {
                    this.questionImg = img;
                    this.imgWidth = img.width;
                    this.imgHeight = img.height;
                    imgCanvas.height = this.imgHeight;
                    imgCanvas.width = this.imgWidth;
                    imgCanvasCtx.drawImage(img, 0, 0);
                    this.imgDataUrl = imgCanvas.toDataURL('image/jpeg');
                    imgCanvas = null;
                    this.imgLoad = true;
                    // 设置设置手写板
                    this.canvasSetSize(this.drawingBoard);
                    this.setCanvasBg('rgba(255,255,255,1)');
                    this.setCanvasColor(this.drawingColor);
                    this.listenToUser(this.drawingBoard)
                }
            },
            // 屏幕图像流生成
            recordLoop () {
                if (!this.isRecordingStarted) {
                    return setTimeout(this.recordLoop, 500)
                }
                this.recordCanvasContext.clearRect(0, 0, this.recordCanvas.width, this.recordCanvas.height);
                this.recordCanvasContext.drawImage(this.drawingBoard, 0, this.elementRecord.scrollTop, this.recordCanvas.width, this.recordCanvas.height, 0, 0, this.recordCanvas.width, this.recordCanvas.height);
                if (this.isStoppedRecording) {
                    return
                }
                setTimeout(() => {
                    requestAnimationFrame(this.recordLoop)
                }, 100)
            },
            // 音视频流获取
            getTracks (stream, kind) {
                if (!stream || !stream.getTracks) {
                    return []
                }
                return stream.getTracks().filter(function (t) {
                    return t.kind === (kind || 'audio')
                })
            },
            // 录制计数
            timeClock () {
                if (this.isRecordingStarted) {
                    this.recorderTime++;
                    setTimeout(this.timeClock, 100)
                }
            },
            // 准备录制
            readyStartRecord () {
                if (this.activeQuestion.explainUrl) {
                    this.$confirm('录制的视频会覆盖题目原来的讲解,是否继续录制？', '提示', {
                        confirmButtonText: '继续',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.startRecord();
                    }).catch(() => {
                    });
                } else {
                    this.startRecord();
                }
            },
            // 开始录制
            startRecord () {
                // if (this.recorder) {
                //     this.isStoppedRecording = false;
                //     this.isRecordingStarted = true;
                //     this.audioStream.open();
                //     this.canvasStream.open();
                //     this.recorderTime = 0;
                //     this.timeClock();
                //     this.recorder.startRecording();
                //     return
                // }
                navigator.mediaDevices.getUserMedia({audio: true, video: false}).then((audioStream) => {
                    // let canvasStream = this.recordCanvas.captureStream()
                    let canvasStream = this.recordCanvas.captureStream();
                    this.canvasStream = canvasStream;
                    this.audioStream = audioStream;
                    let finalStream = new MediaStream();
                    this.getTracks(audioStream, 'audio').forEach(function (track) {
                        finalStream.addTrack(track)
                    });
                    this.getTracks(canvasStream, 'video').forEach(function (track) {
                        finalStream.addTrack(track)
                    });
                    // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    //     this.recorder = new WhammyRecorder(finalStream, {
                    //         type: 'video',
                    //         frameInterval: 10,
                    //         mimeType: 'video/webm;codecs=h264'
                    //     });
                    // } else {
                    //
                    // }
                    this.recorder = RecordRTC(finalStream, {
                        type: 'video',
                        frameInterval: 10,
                        mimeType: 'video/webm;codecs=h264'
                    });
                    this.isStoppedRecording = false;
                    this.isRecordingStarted = true;
                    this.recorderTime = 0;
                    this.timeClock();
                    this.recorder.startRecording()
                }).catch((e) => {
                    alert(String(e))
                })
            },
            // 暂停录制
            pauseRecord () {
                if (!this.recorder) return;
                this.recorder.pauseRecording();
                this.isPauseRecording = true;
                this.isRecordingStarted = false;
                this.isStoppedRecording = true
            },
            // 取消录制
            cancelRecord () {
                if (!this.recorder) return;
                this.recorder.stopRecording(() => {
                    this.isRecordingStarted = false;
                    this.isPauseRecording = false;
                    this.isStoppedRecording = true;
                    this.stopStream();
                    this.recorder.destroy();
                    this.recorder = null;
                });
            },
            // 恢复录制
            resumeRecord () {
                if (!this.recorder) return;
                this.recorder.resumeRecording();
                this.isPauseRecording = false;
                this.isRecordingStarted = true;
                this.isStoppedRecording = false;
                this.timeClock();
            },
            // 停止录制
            stopRecord () {
                if (!this.recorder) return;
                this.recorder.stopRecording(() => {
                    this.isRecordingStarted = false;
                    this.isPauseRecording = false;
                    this.isStoppedRecording = true;
                    this.stopStream();
                    let blob = this.recorder.getBlob();
                    blob = this.blobToFile(blob, `${this.activeQuestion.id}${new Date().getSeconds()}.webm`);
                    this.$refs.ossUpload.ossUploadPolicy(blob, this.activeQuestion.id, this.$store.state.work.activePaper.id);
                    // document.getElementById('preview-video').src = URL.createObjectURL(blob);
                    // document.getElementById('preview-video').parentNode.style.display = 'block';
                    // this.elementRecord.style.display = 'none'
                    // this.recorder.destroy();
                    // this.recorder = null;
                })
            },
            // 上传保存视频
            uploadSuccess (data) {
                if (this.saveQuestionId) {
                    this.setQuestion(this.saveQuestionId);
                    this.saveQuestionId = null;
                }
                // this.activeQuestion.explainUrl = url;
                this.$message({
                    message: '保存成功！',
                    type: 'success'
                });
                this.isEncoding = true;
                if (data[1]) {
                    setTimeout(() => {
                        // 判断是否是当前题目
                        if (String(this.activeQuestion.id) === String(data[2])) {
                            this.getUploadVideo(data[0], data[2]);
                        } else {
                            this.isEncoding = false;
                        }
                    }, 5000)
                } else {
                    this.isEncoding = false;
                    let info = JSON.parse(JSON.stringify(this.activeQuestion));
                    info.explainUrl = data[0];
                    this.activeQuestion = info;
                }
            },
            // 获取上传的视频
            getUploadVideo (url, questionId) {
                url = url.replace('http://', 'https://');
                this.$https.get(url).then(()=>{
                    this.isEncoding = false;
                    if (String(this.activeQuestion.id) === String(questionId)) {
                        let info = JSON.parse(JSON.stringify(this.activeQuestion));
                        info.explainUrl = url;
                        this.activeQuestion = info;
                    }
                },() => {
                    if (String(this.activeQuestion.id) === String(questionId)) {
                        setTimeout(() => {
                            this.getUploadVideo(url, questionId)
                        }, 3000)
                    } else {
                        this.isEncoding = false;
                    }
                }).catch(() => {
                    if (String(this.activeQuestion.id) === String(questionId)) {
                        setTimeout(() => {
                            this.getUploadVideo(url, questionId)
                        }, 3000)
                    } else {
                        this.isEncoding = false;
                    }
                })
            },
            // 上传保存视频失败
            uploadError () {
                // console.log(url);
            },
            // stopStream 关闭视频 音频轨道
            stopStream () {
                this.audioStream.stop();
                this.audioStream = null;
                this.canvasStream.stop();
                this.canvasStream = null;
            },
            // blob 格式转文件
            blobToFile(blob, fileName){
                blob.lastModifiedDate =new Date();
                blob.name = fileName;
                return blob;
            },
            // 设置手写板大小
            canvasSetSize (canvas) {
                const pageWidth = this.elementRecord.clientWidth;
                const y = document.body.clientWidth > 1300 ? 30 : 15;
                this.drawingPage = 1;
                this.drawingTotalPage = Math.ceil((this.imgHeight / (this.elementRecord.clientHeight - y)));
                const pageHeight = this.drawingTotalPage * this.elementRecord.clientHeight;
                canvas.width = pageWidth;
                canvas.height = pageHeight
            },
            // 设置手写板背景
            setCanvasBg (color) {
                this.drawingBoardContext.fillStyle = color;
                this.drawingBoardContext.fillRect(0, 0, this.drawingBoard.width, this.drawingBoard.height);
                this.drawingBoardContext.fillStyle = 'black';
                const x = document.body.clientWidth > 1300 ? 58 : 15;
                const y = document.body.clientWidth > 1300 ? 30 : 15;
                // this.drawingBoardContext.drawImage(this.questionImg, 0, 0, this.questionImg.width, this.questionImg.height, x, y, this.questionImg.width/ 2 + x, this.questionImg.height/ 2 + y)
                this.drawingBoardContext.drawImage(this.questionImg, x, y)
            },
            // 设置手写笔颜色
            setCanvasColor (color) {
                this.drawingBoardContext.fillStyle = color;
                this.drawingBoardContext.strokeStyle = color
            },
            // 设置手写板 鼠标 手势事件
            listenToUser (canvas) {
                let painting = false;
                let lastPoint = {x: undefined, y: undefined};
                let _this = this;
                const ctx = this.drawingBoardContext;
                if (window.PointerEvent) {
                    if (canvas.onpointerdown) return;
                    canvas.onpointerdown = function (e) {
                        this.firstDot = ctx.getImageData(0, 0, canvas.width, canvas.height);// 在这里储存绘图表面
                        _this.saveDrawData(this.firstDot);
                        painting = true;
                        // let x = e.clientX;
                        // let y = e.clientY;
                        const backGroundBox = canvas.getBoundingClientRect();
                        let x = e.clientX - backGroundBox.left * (canvas.width / backGroundBox.width);
                        let y = e.clientY - backGroundBox.top * (canvas.height / backGroundBox.height);
                        lastPoint = {'x': x, 'y': y};
                        ctx.save();
                        _this.drawCircle(x, y, 0);
                        _this.drawLine(x, y, x, y)
                    };
                    canvas.onpointermove = function (e) {
                        if (painting) {
                            // let x = e.clientX;
                            // let y = e.clientY;
                            const backGroundBox = canvas.getBoundingClientRect();
                            if (e.getCoalescedEvents) {
                                for (let coalesced_event of e.getCoalescedEvents()) {
                                    if(coalesced_event.buttons>0) {
                                        let x = coalesced_event.clientX - backGroundBox.left * (canvas.width / backGroundBox.width);
                                        let y = coalesced_event.clientY - backGroundBox.top * (canvas.height / backGroundBox.height);
                                        let newPoint = {'x': x, 'y': y};
                                        _this.drawLine(lastPoint.x, lastPoint.y, newPoint.x, newPoint.y);
                                        lastPoint = newPoint
                                    }
                                }
                            } else {
                                if(e.buttons>0) {
                                    let x = e.clientX - backGroundBox.left * (canvas.width / backGroundBox.width);
                                    let y = e.clientY - backGroundBox.top * (canvas.height / backGroundBox.height);
                                    let newPoint = {'x': x, 'y': y};
                                    _this.drawLine(lastPoint.x, lastPoint.y, newPoint.x, newPoint.y);
                                    lastPoint = newPoint
                                }
                            }
                        }
                    };

                    canvas.onpointerup = function () {
                        painting = false
                    };

                    canvas.onpointerleave = function () {
                        painting = false
                    }
                } else {
                    if (document.body.ontouchstart !== undefined) {
                        if (canvas.ontouchstart) return;
                        canvas.ontouchstart = function (e) {
                            this.firstDot = ctx.getImageData(0, 0, canvas.width, canvas.height);// 在这里储存绘图表面
                            _this.saveDrawData(this.firstDot);
                            painting = true;
                            // let x = e.touches[0].clientX;
                            // let y = e.touches[0].clientY;
                            const backGroundBox = canvas.getBoundingClientRect();
                            let x = e.touches[0].clientX - backGroundBox.left * (canvas.width / backGroundBox.width);
                            let y = e.touches[0].clientY - backGroundBox.top * (canvas.height / backGroundBox.height);
                            lastPoint = {'x': x, 'y': y};
                            ctx.save();
                            _this.drawCircle(x, y, 0);
                            _this.drawLine(x, y, x, y)
                        };
                        canvas.ontouchmove = function (e) {
                            if (painting) {
                                const backGroundBox = canvas.getBoundingClientRect();
                                // let x = e.touches[0].clientX;
                                // let y = e.touches[0].clientY;
                                let x = e.touches[0].clientX - backGroundBox.left * (canvas.width / backGroundBox.width);
                                let y = e.touches[0].clientY - backGroundBox.top * (canvas.height / backGroundBox.height);
                                let newPoint = {'x': x, 'y': y};
                                _this.drawLine(lastPoint.x, lastPoint.y, newPoint.x, newPoint.y);
                                lastPoint = newPoint
                            }
                        };

                        canvas.ontouchend = function () {
                            painting = false
                        }
                    } else {
                        if (canvas.onmousedown) return;
                        canvas.onmousedown = function (e) {
                            this.firstDot = ctx.getImageData(0, 0, canvas.width, canvas.height);// 在这里储存绘图表面
                            _this.saveDrawData(this.firstDot);
                            painting = true;
                            // let x = e.clientX;
                            // let y = e.clientY;
                            const backGroundBox = canvas.getBoundingClientRect();
                            let x = e.clientX - backGroundBox.left * (canvas.width / backGroundBox.width);
                            let y = e.clientY - backGroundBox.top * (canvas.height / backGroundBox.height);
                            lastPoint = {'x': x, 'y': y};
                            ctx.save();
                            _this.drawCircle(x, y, 0);
                            _this.drawLine(x, y, x, y)
                        };
                        canvas.onmousemove = function (e) {
                            if (painting) {
                                // let x = e.clientX;
                                // let y = e.clientY;
                                const backGroundBox = canvas.getBoundingClientRect();
                                let x = e.clientX - backGroundBox.left * (canvas.width / backGroundBox.width);
                                let y = e.clientY - backGroundBox.top * (canvas.height / backGroundBox.height);
                                let newPoint = {'x': x, 'y': y};
                                _this.drawLine(lastPoint.x, lastPoint.y, newPoint.x, newPoint.y);
                                lastPoint = newPoint
                            }
                        };

                        canvas.onmouseup = function () {
                            painting = false
                        };

                        canvas.mouseleave = function () {
                            painting = false
                        }
                    }
                }
            },
            // 手写板画点
            drawCircle (x, y, radius) {
                const ctx = this.drawingBoardContext;
                const canvas = this.drawingBoard;
                const clear = this.isClear;
                ctx.save();
                ctx.beginPath();
                ctx.arc(x, y, radius, 0, Math.PI * 2);
                ctx.fill();
                if (clear) {
                    ctx.clip();
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.restore()
                }
            },
            // 手写板画线
            drawLine (x1, y1, x2, y2) {
                const lineWidth = this.drawingWith;
                const ctx = this.drawingBoardContext;
                const canvas = this.drawingBoard;
                const clear = this.isClear;
                ctx.lineWidth = lineWidth;
                ctx.lineCap = 'round';
                ctx.lineJoin = 'round';
                if (clear) {
                    ctx.save();
                    ctx.globalCompositeOperation = 'destination-out';
                    ctx.moveTo(x1, y1);
                    ctx.lineTo(x2, y2);
                    ctx.stroke();
                    ctx.closePath();
                    ctx.clip();
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.restore()
                } else {
                    ctx.moveTo(x1, y1);
                    ctx.lineTo(x2, y2);
                    ctx.stroke();
                    ctx.closePath()
                }
            },
            // 存储手写历史数据
            saveDrawData (data) {
                (this.historyDrawData.length === 10) && (this.historyDrawData.shift());// 上限为储存10步，太多了怕挂掉
                this.historyDrawData.push(data)
            },
            // 手写板返回上一步
            drawRevocation () {
                if (this.historyDrawData.length < 1) return false;
                const ctx = this.drawingBoardContext;
                ctx.putImageData(this.historyDrawData[this.historyDrawData.length - 1], 0, 0);
                this.historyDrawData.pop()
            },
            // 手写板重置
            drawReset () {
                this.$confirm('重置会清空画板的内容，确定重置吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const ctx = this.drawingBoardContext;
                    const canvas = this.drawingBoard;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    this.setCanvasBg('rgba(255,255,255,1)')
                }).catch(() => {
                });
            },
            // 上一页
            lastElement () {
                if (this.drawingPage <= 1) return;
                this.drawingPage--;
                this.elementScrolling = true;
                this.elementRecord.scrollTo({
                    left: 0,
                    top: (this.drawingPage - 1) * this.elementRecord.clientHeight,
                    behavior: 'smooth'
                });
                this.elementScrolling = false
            },
            // 下一页
            nextElement () {
                if (this.drawingPage >= this.drawingTotalPage) return;
                this.elementScrolling = true;
                this.elementRecord.scrollTo({
                    left: 0,
                    top: this.drawingPage * this.elementRecord.clientHeight,
                    behavior: 'smooth'
                });
                this.elementScrolling = false;
                this.drawingPage++
            },
            fullScreen () {
                this.launchFullscreen()
            },
            backRoute () {
                if (this.isRecordingStarted || this.isPauseRecording) {
                    this.$confirm('正在录制视频，是否离开？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.cancelRecord();
                        this.$router.back(-1)
                    }).catch(() => {
                    });
                } else {
                    this.$router.back(-1)
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    canvas{
        touch-action: none;
    }
    .tt_work_record{
        height: 100%;
        background: white;
        position: relative;
        .tt_record_head{
            height: 80px;
            padding: 0 58px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 22px;
            color: #333333;
            line-height: 22px;
            position: relative;
            .tt_record_head_order{
                height: 22px;
                min-width: 22px;
                padding: 0 8px;
                border-radius: 3px;
                box-sizing: border-box;
                border: 1px solid #333333;
                margin-right: 9px;
            }
        }
        .tt_record_head:before{
            content: '';
            position: absolute;
            left: 58px;
            bottom: 0;
            height: 4px;
            width: calc(100% - 116px);
            background: #F6F6F6;
        }
        .tt_record_container{
            height: calc(100% - 160px);
            position: relative;
            overflow: hidden;
            .element_record{
                vertical-align: top;
                width: calc(100% - 234px);
                height: 100%;
                box-sizing: border-box;
                position: relative;
                overflow-x: hidden;
                float: left;
                text-align: left;
                background: white;
                .element_record_question{
                    position: absolute;
                    z-index: 1;
                    left: 58px;
                    top: 30px;
                }
                .element_record_board{
                    position: relative;
                    z-index: 2;
                    cursor: pointer;
                }
            }
            .video_content{
                width: calc(100% - 234px);
                height: 100%;
                position: relative;
                z-index: 4;
                float: left;
            }
            .tt_record_panel{
                width: 176px;
                margin-top: 30px;
                float: left;
                height: calc(100% - 60px);
                box-shadow:0 0 17px 0 rgba(7, 0, 2, 0.05);
                border-radius:16px;
                background: white;
                position: relative;
                z-index: 3;
            }
            .element_scrolling{
                position: absolute;
                right: 300px;
                bottom: 30px;
                width: 40px;
                z-index: 3;
                height: 60px;
                img{
                    cursor: pointer;
                    width: 40px;
                    display: block;
                    background: white;
                }
                .element_scrolling_top{
                    position: absolute;
                    left: 0;
                    top: -60px;
                    transform: rotate(180deg);
                }
                .element_scrolling_bottom{
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }
        .tt_record_foot{
            height: 80px;
            position: relative;
            z-index: 2;
            -webkit-transform:translateZ(2px);
            transform:translateZ(2px);
            padding: 0 58px;
            background:rgba(255,255,255,1);
            box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
            display: flex;
            align-items: center;
            justify-content: space-between;
            .record_foot_part{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .record_foot_back{
                    width:77px;
                    height:37px;
                    border-radius:5px;
                    border:2px solid rgba(0,144,247,1);
                    color: #0090F7;
                    font-size: 16px;
                    line-height: 37px;
                    padding: 0;
                    background: white;
                }
                .record_btn{
                    cursor: pointer;
                    font-size: 14px;
                    color: #000000;
                    font-weight: 600;
                    line-height: 1;
                    margin-left: 30px;
                    min-width: 50px;
                    .record_start_img{
                        height: 25px;
                        margin-top: 3px;
                        margin-bottom: 4px;
                    }
                    .record_img{
                        height: 29px;
                    }
                    div{
                        white-space: nowrap;
                    }
                }
                .draw_btn{
                    font-size: 14px;
                    color: #29A0FE;
                    line-height: 1;
                    font-weight: 600;
                    margin-right: 25px;
                    cursor: pointer;
                    .revocation_img{
                        height: 24px;
                        margin-bottom: 5px;
                    }
                    .reset_img{
                        height: 24px;
                        margin-bottom: 6px;
                    }
                    .answer_img{
                        width: 23px;
                        margin-top: -1px;
                    }
                }
                .question_btn{
                    width:98px;
                    height:37px;
                    background:rgba(41,150,243,1);
                    border-radius:8px;
                    font-size: 16px;
                    color: #ffffff;
                    padding: 0;
                    line-height: 37px;
                    margin-right: 26px;
                    border: none;
                }
                .selectQuestion{
                    border: none;
                    background: none;
                    font-size: 16px;
                    color: #49AEFE;
                    font-weight: 600;
                }
            }
        }
    }
    @media only screen and (max-width: 1300px){
        .tt_work_record{
            .tt_record_head{
                height: 60px;
                padding: 0 15px;
                font-size: 26px;
                line-height: 30px;
                .tt_record_head_order{
                    height: 30px;
                    min-width: 30px;
                    padding: 0 7px;
                }
            }
            .tt_record_head:before{
                left: 15px;
                width: calc(100% - 30px);
            }
            .tt_record_container{
                height: calc(100% - 130px);
                position: relative;
                overflow: hidden;
                .element_record{
                    width: calc(100% - 200px);
                    .element_record_question{
                        position: absolute;
                        z-index: 1;
                        left: 28px;
                        top: 15px;
                    }
                }
                .video_content{
                    width: calc(100% - 250px);
                }
                .tt_record_panel{
                    margin-top: 15px;
                    height: calc(100% - 30px);
                }
                .element_scrolling{
                    right: 270px;
                    bottom: 15px;
                    width: 40px;
                    z-index: 3;
                    height: 60px;
                }
            }
            .tt_record_foot{
                height: 70px;
                padding: 0 28px;
                .record_foot_part{
                    .record_foot_back{
                        width:107px;
                        height:43px;
                        font-size: 28px;
                        line-height: 43px;
                    }
                    .record_btn{
                        font-size: 16px;
                        margin-left: 34px;
                        min-width: 50px;
                        .record_start_img{
                            height: 30px;
                        }
                        .record_img{
                            height: 35px;
                        }
                        div{
                            white-space: nowrap;
                        }
                    }
                    .draw_btn{
                        font-size: 16px;
                        margin-right: 30px;
                        .revocation_img{
                            height: 27px;
                            margin-bottom: 5px;
                        }
                        .reset_img{
                            height: 27px;
                            margin-bottom: 6px;
                        }
                        .answer_img{
                            width: 26px;
                            margin-top: -1px;
                        }
                    }
                    .question_btn{
                        width:132px;
                        height:43px;
                        font-size: 28px;
                        margin-right: 34px;
                        line-height: 43px;
                    }
                    .selectQuestion{
                        font-size: 20px;
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .work-record-order-dialog{
        padding: 5px;
        .order_container{
            max-height: 200px;
            min-height: 100px;
            overflow: auto;
            .order_content{
                overflow: hidden;
                .order_item{
                    float: left;
                    cursor: pointer;
                    width: 40px;
                    height: 34px;
                    line-height: 34px;
                    background: #d4d4d4;
                    font-size: 22px;
                    color: white;
                    border-radius: 5px;
                    text-align: center;
                    margin: 5px;
                }
                .order_item:hover{
                    background: #2996F3;
                }
                .active{
                    background: #2996F3;
                }
            }
        }
        .order_container::-webkit-scrollbar{
            height: 5px;
            width: 5px;
            background-color: transparent;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
        }
        .order_container::-webkit-scrollbar-thumb {
            border-radius: 6px;
            background-color: rgba(153,153,153,0.3);
        }
        .order_container::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            background   : #ededed;
        }
        .order_container::-webkit-scrollbar-thumb:hover{
            background-color: rgba(153,153,153,0.5);
            cursor: pointer;
        }
        .order_container::-webkit-scrollbar-thumb:active{
            background-color: rgba(153,153,153,0.7);
        }
    }
</style>
